import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Copy, MessageCircle, Instagram, Facebook } from 'lucide-react';
import { mapRuleAcrossPlatforms } from '../../utils/automationRuleMapping';

const PLATFORMS = [
  { id: 'whatsapp', label: 'WhatsApp', icon: MessageCircle, color: '#25D366', path: '/dashboard/meta/automation' },
  { id: 'instagram', label: 'Instagram', icon: Instagram, color: '#E1306C', path: '/dashboard/instagram/automation' },
  { id: 'facebook', label: 'Facebook', icon: Facebook, color: '#1877F2', path: '/dashboard/facebook/automation' },
];

// Mirrors the small-modal pattern used elsewhere (e.g. LinkInstagramModal) —
// pick a target platform, then navigate there with the mapped rule pre-filled
// into that platform's own New Rule form via router state. Nothing is
// created here; the tenant reviews and saves on the target page themselves.
export default function CopyRuleToPlatformModal({ isOpen, onClose, sourcePlatform, rule }) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const targets = PLATFORMS.filter((p) => p.id !== sourcePlatform);

  const handlePick = (target) => {
    const prefillRule = mapRuleAcrossPlatforms(sourcePlatform, rule, target.id);
    onClose();
    navigate(target.path, { state: { prefillRule } });
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-end sm:items-center justify-center sm:p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-t-lg sm:rounded-lg shadow-[0_2px_8px_rgba(0,0,0,0.16)] w-full max-w-sm max-h-[100dvh] overflow-y-auto z-10 animate-in zoom-in-95 duration-200">
        <div className="px-4 sm:px-6 py-3 border-b border-[#E5E5E5] flex items-center justify-between">
          <h3 className="text-[16px] font-bold text-[#2E2E2E] flex items-center gap-2"><Copy size={16} className="text-[#0176D3]" /> Duplicate Rule To</h3>
          <button onClick={onClose} className="text-[#5C5C5C] hover:text-[#2E2E2E]"><X size={18} /></button>
        </div>

        <div className="p-4 sm:p-6 space-y-2">
          <p className="text-[12px] text-[#5C5C5C] px-1 pb-1">
            Keyword, matching type, and reply text carry over. You'll review and finish the rule on the target platform.
          </p>
          {targets.map((p) => (
            <button
              key={p.id}
              onClick={() => handlePick(p)}
              className="w-full flex items-center gap-3 border border-[#E5E5E5] hover:border-[#0176D3] rounded-[4px] px-4 py-3 text-left transition-colors"
            >
              <p.icon size={18} style={{ color: p.color }} />
              <span className="text-[13px] font-semibold text-[#2E2E2E]">{p.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
